// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"12":"profiler","777":"recorder"}[chunkId] || chunkId) + "." + {"12":"6615eff8","453":"1b9726e4","777":"855f015d"}[chunkId] + ".chunk.js";
};